import React from "react";
import { motion } from "framer-motion";

/**
 * Reveal — subtle scroll reveal wrapper.
 * Respects prefers-reduced-motion automatically (framer-motion).
 */
const Reveal = ({
  children,
  delay = 0,
  y = 24,
  className = "",
  once = true,
  ...rest
}) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export default Reveal;
